<template>
  <v-container>
    <h2>
      申し込み書を印刷する
    </h2>
    <br>
    <div class="mb-3 body-2">
      Webからお申込みいただいた後、お申込書は印刷してジャパン・アナリストまで送付ください。<br>
      お申込書の印刷は下記の手順にて実施ください。
    </div>

    <div class="my-8 mb-4">
      <h3>マイページの表示</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      マイページを表示するために、画面上部の「メニュー」から、「マイページ」を選択します。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-entry-confirm-01.png" width="80%" class="my-2">
    </div>

    <div class="mt-10 mb-4">
      <h3>申し込み履歴を開く</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 mt-4 body-2">
      マイページ画面に分析依頼一覧リストの中から、印刷したいお申込みをクリックします。
    </div>
    <div class="ml-4 mt-4 body-2">
      <img src="/img/man-entry-confirm-02.png" width="95%" class="my-2">
    </div>

    <div class="ml-4 mt-4 body-2">
      申し込み履歴画面が開きます
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-entry-confirm-03.png" width="95%" class="my-2">
    </div>

    <div class="mt-10 mb-4">
      <h3>申し込み書を確認する</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 mt-4 body-2">
      画面上部の「申し込み書を確認する」ボタンをクリックします。
    </div>
    <div class="ml-4 mt-4 body-2">
      <img src="/img/man-entry-print-01.png" width="95%" class="my-2">
    </div>

    <div class="mt-10 mb-4">
      <h3>申し込み書を印刷する</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 mt-4 body-2">
      「分析・診断サービス申込書」画面が開きます。上部の「申し込み書を印刷する」ボタンをクリックします。
    </div>
    <div class="ml-4 mt-4 body-2">
      <img src="/img/man-entry-print-02.png" width="95%" class="my-2">
    </div>

    <div class="ml-4 mt-4 body-2">
      申し込み書の印刷プレビュー画面が開きます。<br>
      用紙設定がA4サイズになっていることを確認し、「印刷」ボタンをクリックして印刷します。
    </div>
    <div class="ml-4 mt-4 body-2">
      <img src="/img/man-entry-print-03.png" width="95%" class="my-2">
    </div>

    <div class="my-4">
      <h3>分析・診断サービス申込書画面の項目説明</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      申し込み書画面の各項目の説明です。
    </div>
    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="printData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in printData" :key="item.name">
              <td class="caption" width="140px">{{ item.name }}</td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>

    <div class="my-4">
      <h3>サンプル情報の項目説明</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      サンプル情報の各項目の説明です。
    </div>
    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="sampleData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in sampleData" :key="item.name">
              <td class="caption" width="140px">{{ item.name }}</td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>


  </v-container>
</template>
<script>
export default {
    data: () => ({
        buttonName: '',
        printData: [
          {
            name: 'お申込日',
            body: 'お申込みいただいた日時です',
          },
          {
            name: '予約番号',
            body: 'お申込みしていただいた際に発行される番号です。',
          },
          {
            name: '受注番号',
            body: 'お申込みを受け付けた際に発行される番号です。お申込みを受け付ける前は「採番待ち」となります。',
          },
          {
            name: '分析サンプル',
            body: 'お申込みいただいた分析サンプル数です。サンプルボトル数ではありません。',
          },
          {
            name: 'Web予約番号バーコード',
            body: '予約番号をバーコード化したものです。ジャパン・アナリストではこのバーコードを読み取り着荷を確認します。',
          },
          {
            name: '分析依頼者（報告書、請求書送付先）',
            body: '請求書および納品明細書の送付先です。',
          },
          {
            name: '報告書宛先',
            body: '分析結果報告書の宛名です。ここで指定いただいた方の氏名宛てに報告書を作成します。',
          },
          {
            name: '報告書送付先',
            body: '分析結果報告書の送付先です。ここで指定いただいた方へ報告書を送付します。',
          },
          {
            name: 'サンプル情報',
            body: 'お申込みいただいたサンプルの内容です。サンプル情報の内容は別表にて説明します。',
          },
        ],
        sampleData: [
          {
            name: 'タイトル',
            body: 'サンプルを採取したマイ機器名が表示されます。',
          },
          {
            name: 'カッコ内（機器ID）',
            body: 'カッコでくくられた内容は機器IDです。サンプルを採取したマイ機器IDが表示されます。',
          },
          {
            name: '分析項目',
            body: 'ご依頼いただいたサンプルの分析項目です。セット分析と個別分析の項目名が表示されます。'
          },
          {
            name: '指定納期',
            body: 'ご依頼いただいたサンプルの指定納期です。納期の指定をしていない場合は「指定無し」と表記されます。',
          },
          {
            name: 'サンプルボトル数',
            body: 'ご依頼いただいたサンプルのボトル数です',
          },
          {
            name: 'サンプル量',
            body: 'ご依頼いただいたサンプルのボトル一本あたりのサンプル量です。',
          },
          {
            name: 'サンプルバーコード',
            body: 'サンプルごとに一意に採番されたサンプル番号をバーコード化したものです。ジャパン・アナリストではこのバーコードを読み取りサンプルを識別します。',
          },
        ],
    }),
    methods: {
    }
}
</script>

